import React, { useState, useEffect, useContext } from 'react'
import { Form, Button, Container, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Message from '../components/Message'
import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { getOwnerProfile, updateOwnerProfile } from '../actions/ownerActions.js'
import { OWNER_UPDATE_PROFILE_RESET } from '../constants/ownerConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

const OwnerProfileScreen = () => {
  const { theme } = useContext(ThemeContext)

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  function showAlert(alertMessage, variant = 'success', seconds = 3000) {
    setAlert({
      show: true,
      message: alertMessage,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const ownerProfile = useSelector((state) => state.ownerProfile)
  const { loading, error, owner } = ownerProfile

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const ownerUpdateProfile = useSelector((state) => state.ownerUpdateProfile)
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success
  } = ownerUpdateProfile

  const panelStyle = {
    backgroundColor: theme.card,
    border: `1px solid ${theme.sidebarAccent}`,
    borderRadius: '12px',
    padding: '1.25rem'
  }

  const labelStyle = {
    color: theme.subtext
  }

  const inputStyle = {
    backgroundColor: theme.surfaceMuted,
    color: theme.text,
    borderColor: theme.sidebarAccent
  }

  useEffect(() => {
    if (!ownerInfo) {
      navigate('/owner/login')
      return
    }

    if (!owner || !owner.name) {
      dispatch(getOwnerProfile())
    } else {
      setName(owner.name)
      setEmail(owner.email)
    }
  }, [dispatch, navigate, ownerInfo, owner])

  useEffect(() => {
    if (success) {
      showAlert('Owner profile updated')
      setPassword('')
      setConfirmPassword('')
      dispatch({ type: OWNER_UPDATE_PROFILE_RESET })
    }
  }, [dispatch, success])

  const submitHandler = (e) => {
    e.preventDefault()
    setMessage(null)

    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
      return
    }

    dispatch(updateOwnerProfile({ name, email, password }))
  }

  return (
    <Container className='mt-3' style={{ color: theme.text }}>
      <FormContainer>
        <div style={panelStyle}>
          <h1 style={{ color: theme.text }}>Owner Profile</h1>
          {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
          {message && <Message variant='danger'>{message}</Message>}
          {loadingUpdate && <Loader />}
          {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}

          {loading ?
            <Loader />
          : error ?
            <Message variant='danger'>{error}</Message>
          : <Form onSubmit={submitHandler}>
              <Form.Group className='mb-2' controlId='name'>
                <Form.Label style={labelStyle}>Name</Form.Label>
                <Form.Control
                  readOnly
                  type='text'
                  value={name}
                  style={inputStyle}
                />
              </Form.Group>

              <Form.Group className='mb-2' controlId='email'>
                <Form.Label style={labelStyle}>Email Address</Form.Label>
                <Form.Control
                  readOnly
                  type='email'
                  value={email}
                  style={inputStyle}
                />
              </Form.Group>

              <Form.Group className='mb-2' controlId='password'>
                <Form.Label style={labelStyle}>Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Enter new password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>

              <Form.Group className='mb-2' controlId='confirmPassword'>
                <Form.Label style={labelStyle}>Confirm Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Confirm new password'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>

              <Button type='submit' className='btn btn-outline-primary mt-2'>
                Update
              </Button>
            </Form>
          }
        </div>
      </FormContainer>
    </Container>
  )
}

export default OwnerProfileScreen
